module.exports = __webpack_public_path__ + "img/thumbnail_PronghornAntelope_j_normal.84a159e0.png";